import { Component, OnInit, ElementRef, AfterContentChecked, HostListener } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { environment } from './../../../environments/environment';
import { CfetBaseComponent, CfetPageNamesConstant, CfetService } from '../../cfet-core';

@Component({
    selector: 'app-customer-information',
    templateUrl: './customer-information.component.html',
    styleUrls: ['./customer-information.component.scss'],
    standalone: false
})
export class CustomerInformationComponent extends CfetBaseComponent implements OnInit, AfterContentChecked {

  stepOneIcon = true;
  stepOneSelected = false;
  stepOneTickIcon = false;
  stepOneDone = false;
  stepTwoIcon = true;
  stepTwoSelected = true;
  stepTwoDone = false;
  stepThreeIcon = true;
  stepThreeSelected = false;
  disableStep = true;
  showHeading = true;
  showEligibilitySection = true;
  showInfoSection = false;
  showStepCompleteHeading = false;
  showDesktopEditButton = false;
  showMobileEditButton = false;
  editButtonClicked: boolean;
  signupCompleted = false;
  showWorkPlaceSection = false;
  selectedRole: any;
  selectedWorkPlace: any;
  selectedAddress: any;
  selectedCity: any;
  selectedStateInWorkplace: any;
  selectedZipInWorkplace: any;
  divHeight1: number;
  divHeight2: number;
  eligibilitystoredInfo: any;
  openInactivityModal = '';
  showInactivityModal = true;
  countDown: any;
  checkTimeout = true;
  openCancelModal = '';
  showCancelModal = false;

  constructor(private title: Title,
    private elementRef: ElementRef,
    private router: Router,
    private cfetService: CfetService) { super(); }

  ngOnInit() {
    this.title.setTitle(this.cfetTitles.information.htmlTitle);
    this.cfetService.isLandingPage.next(false);
    if (sessionStorage.getItem('eligibilityInfo') && Object.keys(sessionStorage.getItem('eligibilityInfo')).length !== 0) {
      this.showWorkPlaceSection = true;
      this.stepOneDone = true;
      this.signupCompleted = true;
      this.disableStep = false;
      this.stepTwo();
      const isIPadPro = /Macintosh/.test(navigator.userAgent) && 'ontouchend' in document;
      if (navigator.userAgent.match(/Android/i)
        || navigator.userAgent.match(/webOS/i)
        || navigator.userAgent.match(/iPhone/i)
        || navigator.userAgent.match(/iPad/i)
        || navigator.userAgent.match(/iPod/i)
        || navigator.userAgent.match(/BlackBerry/i)
        || navigator.userAgent.match(/Windows Phone/i)
        || isIPadPro) {
        this.showMobileEditButton = true;
        this.showDesktopEditButton = false;
        this.showWorkPlaceSection = false;
      } else {
        this.showMobileEditButton = false;
        this.showDesktopEditButton = true;
        this.showWorkPlaceSection = true;
      }
      this.eligibilitystoredInfo = JSON.parse(sessionStorage.getItem('eligibilityInfo'));
      this.selectedAddress = this.eligibilitystoredInfo['eligibilityStatus'].selectedAddress;
      this.selectedRole = this.eligibilitystoredInfo['selectedRoleVal'];
      this.selectedWorkPlace = this.eligibilitystoredInfo['eligibilityStatus'].selectedName;
      this.selectedCity = this.eligibilitystoredInfo['eligibilityStatus'].selectedCity;
      this.selectedStateInWorkplace = this.eligibilitystoredInfo['eligibilityStatus'].selectedStateInWorkplace.split(':')[0];
      this.selectedZipInWorkplace = this.eligibilitystoredInfo['eligibilityStatus'].selectedZipInWorkplace;
    }
    if (environment.enableSessionTimeout && this.checkTimeout) {
      this.checkInactivity();
    }
  }

  changeOrientation(event) {
    if (this.signupCompleted && navigator.userAgent.match(/iPad/i) && screen.orientation.type === 'landscape-primary') {
      this.showMobileEditButton = false;
      this.showWorkPlaceSection = true;
      this.showDesktopEditButton = true;
    } else if (this.signupCompleted && navigator.userAgent.match(/iPad/i) && screen.orientation.type === 'portrait-primary') {
      this.showDesktopEditButton = false;
      this.showMobileEditButton = true;
      this.showWorkPlaceSection = false;
    }
  }

  ngAfterContentChecked() {
    this.divheightCalc();
  }

  divheightCalc() {
    const divElem2 = this.elementRef.nativeElement.querySelector('#form-component-section').children[0];
    const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
    if (screen.width > 801) {
      if (divElem2.scrollHeight > (93.4 * vh / 100)) {
        this.divHeight1 = divElem2.scrollHeight;
      } else {
        this.divHeight2 = 93.4 * vh / 100;
        this.divHeight1 = 93.4 * vh / 100;

      }
    } else {
      const formcomponentsection = this.elementRef.nativeElement.querySelector('#form-component-section');
      const progresstrackerelement = this.elementRef.nativeElement.querySelector('#progress-tracker');
      const bodyelement = this.elementRef.nativeElement.querySelector('#cutomer-information-screen').children[0];
      if (bodyelement.scrollHeight <= progresstrackerelement.scrollHeight + formcomponentsection.scrollHeight) {
        const bodyHeight = formcomponentsection.scrollHeight + progresstrackerelement.scrollHeight;
        bodyelement.style.height = bodyHeight + 'px';
      } else {
        bodyelement.style.height = 70.4 * vh / 100 + 'px';
      }
    }
  }

  stepTwo() {
    if (this.disableStep) {
      this.stepTwoSelected = false;
    } else {
      this.stepTwoSelected = true;
      this.stepOneSelected = false;
      this.stepThreeSelected = false;
    }
  }

  goToEligibility(event) {
    if (event && event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.editButtonClicked = true;
      this.disableStep = true;
      this.eligibilitystoredInfo['action'] = 'Profile Info';
      // disable Second Step and go to Step One
      sessionStorage.setItem('eligibilityInfo', JSON.stringify(this.eligibilitystoredInfo));
      this.router.navigate([CfetPageNamesConstant.CUSTOMER_ELIGIBILITY]);
      this.stepOneIcon = true;
      this.stepOneTickIcon = false;
      this.showHeading = true;
      this.showStepCompleteHeading = false;
      this.showDesktopEditButton = false;
      this.showMobileEditButton = false;
      this.stepOneDone = false;
      this.showWorkPlaceSection = false;
      clearInterval(this.countDown);
    }
  }

  hideEditButton(event) {
    if (event) {
      this.showDesktopEditButton = false;
      this.showMobileEditButton = false;
    }
  }

  goToInstantVerification1(event) {
    if (event) {
      this.stepTwoIcon = false;
      this.stepTwoDone = true;
    }
  }

  closeInactivityModal(event) {
    if (event === 'modalClose') {
      this.openInactivityModal = 'close';
    }
  }

  setSessionTimeout(event) {
    if (event) {
      this.checkTimeout = false;
      clearInterval(this.countDown);
    }
  }

  @HostListener('window:load')
  @HostListener('document:mousemove')
  @HostListener('document:keyup')
  @HostListener('document:click')
  @HostListener('window:scroll')
  @HostListener('document:touchstart', ['$event']) onMove($event?: any) {
    if (environment.enableSessionTimeout && this.checkTimeout) {
      clearInterval(this.countDown);
      this.checkInactivity();
    }
  }

  checkInactivity() {
    const countDownDate = new Date().getTime() + 120000;
    this.countDown = setInterval(() => {
      const currentTime = new Date().getTime();
      const timeDiff = countDownDate - currentTime;
      if (timeDiff < 0) {
        clearInterval(this.countDown);
        this.openInactivityModal = 'close';
        sessionStorage.clear();
        window.location.href = CfetPageNamesConstant.SESSION_TIME_OUT;
      }
      if (timeDiff < 30000) {
        this.openInactivityModal = 'open';
        this.showCancelModal = false;
      }
    }, 350);
  }

  cancelModal(event) {
    if (event) {
      this.showCancelModal = true;
      this.openCancelModal = 'open';
    }
  }

  closeModal(event) {
    if (event === 'modalClose') {
      this.openCancelModal = 'close';
    }
  }

}
